import { LocaleService } from 'gw-portals-i18n-react';
import { service } from '@jutro/legacy/services';
import { LocaleUtil } from '@xengage/gw-portals-util-js';

export const LOCALE_SERVICE_ID = 'locale-service';


const currencySymbols = {
    'aud': '$',
    'cad': '$',
    'eur': '\u20ac',
    'gbp': '\u00a3',
    'jpy': '\u00a5',
    'rub': '\u20BD',
    'usd': '$',
    'chf': 'Fr.',
    'cny': '\u00a5',
    'nzd': '$'
};

class MLLocaleService extends LocaleService {
    getCurrencySymbol(currency) {
        return currencySymbols[currency] || '\u00A4';
    }

    static register() {
        service(LOCALE_SERVICE_ID, {
            implements: LocaleUtil.LocaleSettingsInterface
        })(MLLocaleService);
    }
}

export default MLLocaleService;